import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import blueaddicon from "../../assets/images/blueaddicon.svg";
import closeImage from "../../assets/images/close-white.svg";
import { default as infoIcon } from "../../assets/images/infobtnblue.svg";
import { apiResponse } from "../../services/APIResponse";
import { API_URL } from "../../services/APIRoute";
import { commonservices } from "../../services/CommonServices";
import { UpdateReviewComment } from "../../services/ReduxTookit/Slice/MachineRedux";
import SubmitLoading from "../common-component/Loaders/SubmitLoading";
import robot from "../../assets/images/robot.gif";
import AIImageGenerateModal from "../../Modals/AIImageGenerateModal";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";
import DemoLogoBig from "../../assets/images/MainLogoforMPD.svg";
import DemoLogo from "../../assets/images/quantummain.svg";
import { createPortal } from "react-dom";
const BannerEdit = ({
  getlist,
  machineId,
  handleclose,
  bindlist,
  versionlist,
  updatereviewcommentdata,
  geteditstatus,
  setmachinedetails,
  setmainimage,
}) => {
  const countFalseValues = () => {
    return Object.values(geteditstatus).filter((value) => value === false)
      .length;
  };
  const [BannerImgValidation, setBannerImgValidation] = useState(
    "This Field is a required field."
  );
  const [AIModalShow, setAIModalShow] = useState(false);
  const [MachineLoader, setMachineLoader] = useState(false);
  const [MultiSelectValidation, setMultiSelectValidation] = useState({
    machinebanner: false,
    machinelogo: false,
  });
  const MachineLogoref = useRef();
  const dispatch = useDispatch();
  const [BannerImageState, setBannerImageState] = useState("");
  const [input, setInput] = useState({
    machineid: machineId ? machineId : 0,
    price: "",
    subcategoryid: 0,
    osrequirmet: "",
    storage: "",
    ram: "",
    cpu: "",
    compatiblemachineids: [],
    dependentmachineids: [],
    machinebanner: [],
    cloud: [],
    errors: {
      machineid: "",
      subcategoryid: "",
      ValidationRules: [
        {
          FieldName: "subcategoryid",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  const MachineBannerFileChange = async (e) => {
    const files = e?.target?.files;
    if (!files) return;
    let totalSize = 0;
    let temp = [];
    let invalidDimensions = false;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const img = new Image();
      img.src = URL.createObjectURL(file);
      await new Promise((resolve) => {
        img.onload = () => {
          if (
            img.width < 1400 ||
            img.width > 1450 ||
            img.height < 400 ||
            img.height > 450
          ) {
            invalidDimensions = true;
            toast.error(
              `Image dimensions for "${file.name}" must be between 1400-1450px width and 400-450px height.`
            );
          }
          resolve();
        };

        img.onerror = () => {
          toast.error(`Invalid file: "${file.name}"`);
          resolve();
        };
      });
      if (invalidDimensions) return;
      temp.push(file);
      totalSize += file?.size;
    }
    if (input?.machinebanner?.length > 0) {
      totalSize += input.machinebanner.reduce(
        (sum, file) => sum + file.size,
        0
      );
    }
    const combinedFiles =
      input?.machinebanner?.length > 0
        ? [...input.machinebanner, ...temp]
        : temp;
    if (combinedFiles.length > 7) {
      setBannerImgValidation("You can upload a maximum of 7 images.");
      setMultiSelectValidation({
        ...MultiSelectValidation,
        machinebanner: true,
      });
      return;
    }
    if (totalSize > 5000000) {
      setBannerImgValidation(
        "File size must not exceed 5 MB, and a maximum of 7 images can be uploaded."
      );
      setMultiSelectValidation({
        ...MultiSelectValidation,
        machinebanner: true,
      });
      return;
    }
    setBannerImageState(e?.target?.files?.[0]);
    setInput({
      ...input,
      machinebanner: combinedFiles,
    });
    setMultiSelectValidation({
      ...MultiSelectValidation,
      machinebanner: false,
    });
    setBannerImgValidation("");
  };
  const updateReviewStatus = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    let updatedValidation = { ...MultiSelectValidation };
    let totalBannerSize = 0;
    if (input?.machinebanner?.length > 0) {
      totalBannerSize = input.machinebanner.reduce(
        (acc, banner) => acc + (banner?.size || 0),
        0
      );
      if (totalBannerSize > 5000000 || input.machinebanner.length > 7) {
        updatedValidation.machinebanner = true;
        setBannerImgValidation(
          "File size must not exceed 5 MB, and a maximum of 7 images can be uploaded."
        );
      } else {
        updatedValidation.machinebanner = false;
        setBannerImgValidation("");
      }
    } else {
      updatedValidation.machinebanner = true;
      setBannerImgValidation("At least one image is required.");
    }
    setMultiSelectValidation(updatedValidation);
    if (obj.isValid && !updatedValidation.machinebanner) {
      setMachineLoader(true);
      let newbody = {
        machineid: versionlist?.machineid,
        versionnumber: versionlist?.number,
        booleanfield: updatereviewcommentdata?.booleanfield,
        commentfield: updatereviewcommentdata?.commentfield,
        commentfieldvalue: updatereviewcommentdata?.commentfieldvalue,
      };

      dispatch(UpdateReviewComment(newbody))?.then((response) => {
        if (response?.payload?.isValidate) {
          handleUpdate();
        }
        if (!response?.payload?.isValidate) {
        }
      });
    }
  };
  const handleUpdate = async (e) => {
    let formData = new FormData();
    let body = {
      machineid: parseInt(input?.machineid),
      subcategoryid: input?.subcategoryid ? input?.subcategoryid : 0,
      price: input?.price ? input?.price : 0,
      osrequirmet: input?.osrequirmet ? input?.osrequirmet : "",
      storage: input?.storage ? input?.storage : "",
      ram: input?.ram ? input?.ram : "",
      cpu: input?.cpu ? input?.cpu : "",
      cloud: input?.cloud ? input?.cloud : "",
      compatiblemachineids: input?.compatiblemachineids
        ? input?.compatiblemachineids
        : "",
      dependentmachineids: input?.dependentmachineids
        ? input?.dependentmachineids
        : "",
    };
    for (const [key, value] of Object.entries(body)) {
      if (
        typeof value === "object" &&
        Array.isArray(value) &&
        key !== "componentjson"
      ) {
        value?.map((item, index) => {
          for (const [nestedKey, nestedValue] of Object.entries(item)) {
            formData.append(`${key}[${index}].${nestedKey}`, nestedValue);
          }
        });
      } else {
        formData.append(`${key}`, value);
      }
    }
    input?.machinebanner?.forEach((file, index) => {
      formData.append(
        `machinebanner[${index}].banner`,
        typeof file === "object" ? file : ""
      );
      formData.append(
        `machinebanner[${index}].bannerurl`,
        typeof file !== "object" ? file : ""
      );
    });
    if (countFalseValues() === 1) {
      formData.append(`status`, "In Process");
    } else {
      formData.append(`status`, "Rejected");
    }
    let resData = await axios({
      method: "PUT",
      url: API_URL.BASEURL + API_URL?.MACHINE?.UPDATE_MACHINE,
      data: formData,
      headers: commonservices.getHeadersFromData(),
    });
    let response = apiResponse(true, resData?.data, setMachineLoader);
    
    if (response?.isValidate) {
      handleclose();
      const updatedMachineDetails = {
        ...getlist,
        dataList5: [
          ...(response?.data?.data?.banner || []).map((banner, index) => ({
            bannerurl: banner?.filename,
          })),
        ],
      };
      setmachinedetails(updatedMachineDetails);
      setmainimage(response?.data?.data?.banner?.[0]?.filename);
    }
    if (!response?.isValidate) {
      setMachineLoader(false);
    }
  };

  useEffect(() => {
    let temp = [];
    if (getlist?.dataList5?.length > 0) {
      getlist?.dataList5.forEach((element) => {
        temp.push(element?.bannerurl);
      });
    }
    setInput({
      ...input,
      machineid: getlist?.dataList1[0]?.machineid
        ? getlist?.dataList1[0]?.machineid
        : 0,
      price: getlist?.dataList1[0]?.price ? getlist?.dataList1[0]?.price : 0,
      subcategoryid: getlist?.dataList1[0]?.subcategoryid
        ? getlist?.dataList1[0]?.subcategoryid
        : 0,
      osrequirmet: getlist?.dataList2[0]?.osrequirmet
        ? getlist?.dataList2[0]?.osrequirmet
        : "",
      storage: getlist?.dataList2[0]?.storage
        ? getlist?.dataList2[0]?.storage
        : "",
      ram: getlist?.dataList2[0]?.ram ? getlist?.dataList2[0]?.ram : "",
      cpu: getlist?.dataList2[0]?.cpu ? getlist?.dataList2[0]?.cpu : "",
      cloud: getlist?.dataList2[0]?.cloud ? getlist?.dataList2[0]?.cloud : "",
      compatiblemachineids: getlist?.dataList2[0]?.compatiblemachineids
        ? getlist?.dataList2[0]?.compatiblemachineids
        : [],
      dependentmachineids: getlist?.dataList2[0]?.dependentmachineids
        ? getlist?.dataList2[0]?.dependentmachineids
        : [],
      machinebanner: temp ? temp : [],
    });
    setBannerImageState(temp[0]);
  }, [getlist]);

  // Add or remove 'loadtime' class based on MachineLoader

  useEffect(() => {
    if (MachineLoader) {
      document.body.classList.add("loadtime");
    }
    // else {
    //   document.body.classList.remove('loadtime');
    // }

    // Cleanup when component unmounts
    return () => {
      document.body.classList.remove("loadtime");
    };
  }, [MachineLoader]); // Re-run this effect when MachineLoader changes

  const LoaderPortal = ({ children }) => {
    return createPortal(children, document.body);
  };  

  return (
    <div className="banner-edit-main">
      {MachineLoader && (
        <LoaderPortal>
          <MainpageLoader />
        </LoaderPortal>
      )}
      <div className="position-relative mb12">
        <div
          className={` ${
            MultiSelectValidation.machinebanner && "error-border-line"
          }`}
        >
          {input?.machinebanner?.length > 0 ? (
            <div className="drop-file-input ">
              {BannerImageState !== "" ? (
                <>
                  <img
                    className="banner-img-one"
                    alt="BannerImage"
                    src={
                      typeof BannerImageState === "object"
                        ? URL.createObjectURL(BannerImageState)
                        : BannerImageState
                    }
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = DemoLogoBig;
                    }}
                  />
                  <div className="airobot cursor-pointer">
                    <img
                      src={robot}
                      alt="robot"
                      onClick={(e) => {
                        setAIModalShow(true);
                      }}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="drop-file-input__label d-block">
                    <div>
                      <h5>Drag 'n' drop files here</h5>
                      <p>
                        Banner Images - Supported only jpg, jpeg & png files
                      </p>
                      <p className="red-color-text">
                        Height between 400 to 450 PX and Width between 1400 to
                        1450 PX
                      </p>
                    </div>
                    <Button className="blue-btn w-auto position-static">
                      Choose Files
                    </Button>
                  </div>
                  <input
                    type="file"
                    id="machinebanner"
                    ref={MachineLogoref}
                    multiple
                    title=""
                    accept=".jpg, .jpeg, .png"
                    onChange={MachineBannerFileChange}
                  />
                </>
              )}
            </div>
          ) : (
            <div className="drop-file-input">
              <div className="drop-file-input__label d-block">
                <div>
                  <h5>Drag 'n' drop files here</h5>
                  <p>Banner Images - Supported only jpg, jpeg & png files</p>
                  <p className="red-color-text">
                    Height between 400 to 450 PX and Width between 1400 to 1450
                    PX
                  </p>
                </div>
                <Button className="blue-btn w-auto position-static">
                  Choose Files
                </Button>
              </div>
              <input
                type="file"
                id="machinebanner"
                ref={MachineLogoref}
                multiple
                title=""
                accept="image/png, image/jpeg"
                onChange={MachineBannerFileChange}
              />
              <div className="mainairobot-data d-flex">
                <div className="airobot cursor-pointer">
                  <img
                    src={robot}
                    alt="robot"
                    onClick={(e) => {
                      setAIModalShow(true);
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          {input?.machinebanner?.length > 0 && (
            <div className="all-sm-images-wrapper">
              {input?.machinebanner?.map((item_mb, index_mb) => (
                <div
                  key={index_mb}
                  className="single-sm-images-wrapper position-relative"
                >
                  <img
                    onClick={(e) => {
                      e.preventDefault();
                      setBannerImageState(item_mb);
                    }}
                    src={
                      typeof item_mb === "object"
                        ? URL.createObjectURL(item_mb)
                        : item_mb
                    }
                    alt={item_mb}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = DemoLogo;
                    }}
                  />
                  <button
                    type="reset"
                    className="delete-img"
                    onClick={(e) => {
                      e.preventDefault();
                      const updatedMachineBanner = [...input?.machinebanner];
                      updatedMachineBanner.splice(index_mb, 1);
                      const totalmb = updatedMachineBanner.reduce(
                        (sum, file) => sum + file?.size,
                        0
                      );
                      setInput({
                        ...input,
                        machinebanner: updatedMachineBanner,
                      });
                      if (updatedMachineBanner.length > 7) {
                        setMultiSelectValidation({
                          ...MultiSelectValidation,
                          machinebanner: true,
                        });
                        setBannerImgValidation(
                          "You can upload a maximum of 7 images."
                        );
                      } else if (totalmb > 5000000) {
                        setMultiSelectValidation({
                          ...MultiSelectValidation,
                          machinebanner: true,
                        });
                        setBannerImgValidation(
                          "File size must not exceed 5 MB, and a maximum of 7 images can be uploaded."
                        );
                      } else {
                        setBannerImageState(updatedMachineBanner[0]);
                        setMultiSelectValidation({
                          ...MultiSelectValidation,
                          machinebanner: false,
                        });
                        setBannerImgValidation("");
                      }
                    }}
                  >
                    <img src={closeImage} alt="deleteIcon" />
                  </button>
                </div>
              ))}
              <label className="only-plus-input-type-file" for="machinebanner">
                <div className="only-plus-input-typ-file-addbutton">
                  <img src={blueaddicon} alt="blueaddicon" />
                </div>
                <input
                  type="file"
                  className="form-control"
                  id="machinebanner"
                  ref={MachineLogoref}
                  multiple
                  title=""
                  accept="image/png, image/jpeg"
                  onChange={MachineBannerFileChange}
                />
              </label>
            </div>
          )}
          {MultiSelectValidation.machinebanner && (
            <p className="error-line">
              <span className="error-message-icon">
                <img
                  src={infoIcon}
                  alt="infoIcon"
                  title={BannerImgValidation}
                />
              </span>
            </p>
          )}
        </div>
      </div>
      <div className="machin-detail-footer-btns">
        <button className="grey-btn" onClick={() => handleclose()}>
          Cancel
        </button>
        <button
          className="blue-btn"
          disabled={MachineLoader}
          // onClick={(e) => handleUpdate(e)}
          onClick={(e) => updateReviewStatus(e)}
          // type="submit"
        >
          {MachineLoader ? (
            // <>
            //   <span>Loading</span>{" "}
            //   <Spinner
            //     className="ms-1"
            //     animation="border"
            //     role="status"
            //     size="sm"
            //   >
            //     <span className="visually-hidden">Loading...</span>
            //   </Spinner>
            // </>
            <SubmitLoading />
          ) : (
            "Submit"
          )}
        </button>
      </div>
      {AIModalShow && (
        <AIImageGenerateModal
          setbannerimagestate={setBannerImageState}
          show={AIModalShow}
          input={input}
          setinput={setInput}
          onHide={(e) => setAIModalShow(false)}
        />
      )}
    </div>
  );
};

export default BannerEdit;
